import { getCookie, getLocalItem } from './token'
import { startLogin } from './startLogin'

export function hasLoginSession() {
  const hasToken = (value) => typeof value === 'string' && Boolean(value.trim())
  if (hasToken(getLocalItem('access_token')) || hasToken(getCookie('token'))) {
    return true
  }
  try {
    const userInfo = JSON.parse(getLocalItem('useInfo') || 'null')
    return hasToken(userInfo?.access_token) || hasToken(userInfo?.token)
  } catch {
    return false
  }
}

// 在上传入口先校验登录，避免先打开文件选择器或验证码。
export function requireLoginSession() {
  if (hasLoginSession()) return true
  startLogin()
  return false
}

// 体验入口复用现有登录态；接口返回 401 时仍由原认证流程重新登录。
export function goToExperience(router, target) {
  const base = import.meta.env.BASE_URL.replace(/\/$/, '')
  const location = typeof target === 'string' && target.startsWith(`${base}/`)
    ? target.slice(base.length)
    : target
  if (hasLoginSession()) return router.push(location)

  const returnUrl = new URL(router.resolve(location).href, window.location.origin)
  return startLogin(null, returnUrl.href)
}
